
const Star = ({ lists, handleSelectChange, disableSend }) => {
  return (
    <>
      {lists.map((list) => (
        <div key={list.id}>
          <hr />

          <fieldset className="row gy-2 gx-6 list-suggest" style={{ border: 0, padding: 0, margin: 0 }}>
            <legend className="visually-hidden">
              {list.name} 評分，請選擇 1 至 5 顆星
            </legend>

            <div className="form-check col-2">
              {list.name}
            </div>

            <div className="form-check col-2">
              <label htmlFor={list.id + "star5"}>
                <input id={"rating-" + list.id + "star5"} defaultChecked className="form-check-input" type="radio" name={"rating-" + list.id}
                       value="5" onChange={handleSelectChange} required disabled={disableSend} aria-label={`${list.name} 5 顆星`}/>
                <span aria-hidden="true">
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                </span>
              </label>
            </div>

            <div className="form-check col-2">
              <label htmlFor={list.id + "star4"}>
                <input id={"rating-" + list.id + "star4"} className="form-check-input" type="radio" name={"rating-" + list.id}
                    value="4" disabled={disableSend} onChange={handleSelectChange} aria-label={`${list.name} 4 顆星`}/>
                <span aria-hidden="true">
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                </span>
              </label>
            </div>

            <div className="form-check col-2">
              <label htmlFor={list.id + "star3"}>
                <input id={"rating-" + list.id + "star3"} className="form-check-input" type="radio" name={"rating-" + list.id}
                    value="3" disabled={disableSend} onChange={handleSelectChange} aria-label={`${list.name} 3 顆星`}/>
                <span aria-hidden="true">
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                </span>
              </label>
            </div>

            <div className="form-check col-2">
              <label htmlFor={list.id + "star2"}>
                <input id={"rating-" + list.id + "star2"} className="form-check-input" type="radio" name={"rating-" + list.id}
                    value="2" disabled={disableSend} onChange={handleSelectChange} aria-label={`${list.name} 2 顆星`}/>
                <span aria-hidden="true">
                  <i className="bx bxs-star"></i>
                  <i className="bx bxs-star"></i>
                </span>
              </label>
            </div>

            <div className="form-check col-auto">
              <label htmlFor={list.id + "star1"}>
                <input id={"rating-" + list.id + "star1"} className="form-check-input" type="radio" name={"rating-" + list.id}
                    value="1" disabled={disableSend} onChange={handleSelectChange} aria-label={`${list.name} 1 顆星`}/>
                <span aria-hidden="true">
                  <i className="bx bxs-star"></i>
                </span>
              </label>
            </div>

          </fieldset>
        </div>
      ))}
    </>
  )
}

export default Star
